import { render, staticRenderFns } from "./TotalVendaRenderer.vue?vue&type=template&id=54184266&scoped=true&"
import script from "./TotalVendaRenderer.vue?vue&type=script&lang=js&"
export * from "./TotalVendaRenderer.vue?vue&type=script&lang=js&"
import style0 from "./TotalVendaRenderer.vue?vue&type=style&index=0&id=54184266&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54184266",
  null
  
)

export default component.exports